import React from 'react';
import { motion } from 'framer-motion';
export function PromiseTransformation() {
  return <section className="py-16 md:py-24 px-4 bg-bg-secondary" data-id="element-230">
      <div className="max-w-4xl mx-auto" data-id="element-231">
        <motion.h2 className="font-heading text-3xl md:text-4xl font-bold text-heading mb-8 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-232">
          Imagina esto:
        </motion.h2>

        <motion.div className="space-y-6 text-lg leading-relaxed text-body" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-233">
          <p data-id="element-234">
            La próxima vez que notes algún síntoma, no entras en pánico. No
            corres a la farmacia sin saber qué pedir. No buscas durante cuarenta
            minutos entre páginas contradictorias.
          </p>

          <p data-id="element-235">
            Simplemente sabes qué observar, qué significa, cuándo puedes esperar
            y cuándo debes consultar. Tienes hábitos que protegen tu bienestar
            íntimo. Y si los episodios se repiten, sabes exactamente qué
            preguntas llevarle a tu médico.
          </p>

          <p className="font-semibold" data-id="element-236">
            Eso es lo que esta guía puede darte. No una cura milagrosa. Sino
            algo mucho más valioso: claridad y confianza para cuidar tu salud
            íntima.
          </p>
        </motion.div>
      </div>
    </section>;
}